import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { InformationFlow } from '@ifeng-fe/three_terminal/es/mobile/index';
import { getFeedFlowList } from '../../../../services/api';
import { handleVideoStream } from '../../../../utils/formatVideoList';

class NewsStreamWrapper extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        columnId: PropTypes.string,
        ad: PropTypes.object,
    };

    state = {
        pagination: {
            current: 1,
            pageSize: 20,
        },
        data: new Array(),
        isEnd: false,
    };

    componentDidMount() {
        this.initData();
    }

    // 获取视频数据
    asyncGetVideoStream = async (page, pageSize) => {
        const { columnId } = this.props;
        // const res = await getVideoStream(page, pageSize, columnId, 1);
        const _res = await getFeedFlowList('df', columnId, page, pageSize, 'seo');

        const res = {
            data: [],
            total: 0,
        };

        if (_res && _res.code) {
            res.data = handleVideoStream(_res.data, 1);
            res.total = _res.totalPage;

            console.log(_res);
        }

        return res;
    };

    // 初始化数据
    initData = () => {
        const { content } = this.props;

        if (content) {
            const data = content.slice(0, 20);

            this.setState({
                data,
            });
        }
    };

    // 分页获取新闻数据
    getCustomNewsTfList = async ({ current, pageSize }) => {
        try {
            const res = await this.asyncGetVideoStream(current, pageSize);

            // console.log(res);

            const result = {
                news: res.data || [],
                total: res.total,
            };

            return result;
        } catch (e) {
            console.log(e);
        }
    };

    handleLoadMore = async () => {
        console.log('点击加载');
        if (this.state.isEnd)
            return {
                content: [],
                isEnd: true,
            };
        this.setState({
            // 每次重置当前页
            pagination: {
                current: this.state.pagination.current + 1,
                pageSize: 20,
            },
            loading: true,
        });
        const req = await this.getCustomNewsTfList(this.state.pagination);
        const { news, total } = req;
        const result = news;
        let returnData = {};

        if (Object.prototype.toString.call(result) === '[object Array]') {
            if (this.state.pagination.current < total) {
                this.setState(
                    {
                        data: result,
                    },
                    () => {
                        returnData = {
                            content: this.state.data,
                            isEnd: false,
                        };
                    },
                );
            } else {
                this.setState(
                    {
                        data: result,
                        isEnd: true,
                    },
                    () => {
                        returnData = {
                            content: this.state.data,
                            isEnd: true,
                        };
                    },
                );
            }
        }

        return returnData;
    };

    render() {
        const { ad } = this.props;
        const { data, isEnd } = this.state;
        // const ad = {
        //     data: {},
        //     preload: '',
        //     callback: (data, event, insert) => {
        //         let box1 = document.createElement('div');

        //         box1.innerHTML = 'qqqqqq';
        //         // insert([], [0], function(dom) {
        //         //     console.log(dom)
        //         //     dom[0].appendChild(box1);
        //         // });
        //         event.on('init', data => {
        //             // data 为我们触发方法时传参值
        //             const insertArr = [];

        //             const replaceArr = [3];

        //             insert(insertArr, replaceArr, dom => {
        //                 console.log(dom);
        //                 dom[3].appendChild(box1);
        //             });
        //         });
        //     },
        // };

        return (
            <Fragment>
                <div className={styles.newsStream}>
                    {data && data.length > 0 ? (
                        <InformationFlow
                            content={data}
                            // videoSource={'ifengVideos'}
                            isCount={true}
                            // getVideoPlayNum
                            isEnd={isEnd}
                            isScrollLoadingData={!isEnd}
                            isDisplayLoadingMore={false}
                            isLazyImage
                            handleLoadingDataFunc={this.handleLoadMore}
                            ad={[ad]}
                        />
                    ) : null}
                </div>
            </Fragment>
        );
    }
}

export { NewsStreamWrapper };
export default NewsStreamWrapper;
